document.addEventListener("DOMContentLoaded", () => {
    const thumbsUpBtn = document.querySelector("button.up");
    const thumbsDownBtn = document.querySelector("button.down");
    const thumbsSendBtn = document.querySelector("button.send");

    const messageContainer = document.querySelector(".thumbs-message-container");
    const buttonContainer = document.querySelector(".thumbs-button-container");

    const thumbValue = document.querySelector(".thumb-input");
    const pageValue = document.querySelector(".page-input");

    if (thumbsUpBtn) {
        thumbsUpBtn.addEventListener("click", function () {
            thumbValue.value = "up";
            pageValue.value = window.location.pathname;
            messageContainer.classList.toggle("show");
            buttonContainer.classList.toggle("show");

            gtag("event", "_sendThumb", {
                event_label: "thumbs",
                value: "up",
            });
        });
        thumbsDownBtn.addEventListener("click", function () {
            thumbValue.value = "down";
            pageValue.value = window.location.pathname;
            messageContainer.classList.toggle("show");
            buttonContainer.classList.toggle("show");

            gtag("event", "_sendThumb", {
                event_label: "thumbs",
                value: "down",
            });
        });
        thumbsSendBtn.addEventListener("click", function (event) {
            event.preventDefault();
            sendThumb();
        });
    }
});

function sendThumb() {
    const messageContainer = document.querySelector(".thumbs-message-container");
    const responseContainer = document.querySelector(".thumbs-response-container");
    const form = document.querySelector("#thumbsForm");

    grecaptcha.ready(function () {
        grecaptcha.execute("6Le8O3gtAAAAAPDalBy4h1ix44CvykVkukl5JgXU", { action: "submit" }).then(function (token) {
            form.insertAdjacentHTML(
                "afterbegin",
                `<input type="hidden" name="g-recaptcha-response" value="${token}" />`,
            );

            const formData = new FormData(form);

            const object = {};
            formData.forEach((value, key) => (object[key] = value));

            const headers = new Headers({
                "Content-Type": "application/json",
            });
            const options = {
                method: "POST",
                headers: headers,
                body: JSON.stringify(object),
            };

            fetch(form.action, options)
                .then((res) => res.json())
                .then((res) => {
                    if (res.success) {
                        responseContainer.classList.toggle("show");
                        messageContainer.classList.toggle("show");
                    } else {
                        console.error(res.reason);
                    }
                });
            return false;
        });
    });
}
